import {isPlatformBrowser} from '@angular/common';
import {Component, DOCUMENT, inject, OnInit, PLATFORM_ID} from '@angular/core';
import {Observable} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {BaseComponent} from '../components/base.component';

/** Минимальный контракт сервиса локали для общего переключателя (admin + customer). */
export interface LocaleSwitcherService<L extends string> {
  changes(): Observable<L>;
  set(locale: L): void;
}

/**
 * Общая логика переключателя локали для обоих приложений: подписка на `changes()`
 * (с `takeUntil(unsubscribe)` от BaseComponent), `select()` + перезагрузка страницы.
 *
 * За подклассом остаётся UI (шаблон/стили — кнопки `RU|EN` в admin, `<select>` в
 * customer), начальное `active`, `hidden`-условие и подстановка конкретного сервиса
 * через `service`.
 */
@Component({template: ''})
export abstract class LocaleSwitcherBase<L extends string> extends BaseComponent implements OnInit {
  abstract active: L;
  protected abstract readonly service: LocaleSwitcherService<L>;

  private readonly platformId = inject(PLATFORM_ID);
  private readonly document = inject(DOCUMENT);

  ngOnInit() {
    this.service.changes()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(locale => {
        this.active = locale;
        this.cdr.markForCheck();
      });
  }

  select(locale: L) {
    if (this.active === locale) return;
    this.service.set(locale);
    if (isPlatformBrowser(this.platformId)) {
      // Перезагрузка → весь грид/карточка/фильтры перезапросятся в новой локали.
      this.document.defaultView?.location.reload();
    }
  }
}
